/* eslint-disable no-unused-expressions */
/* eslint-disable react/static-property-placement */
/* eslint-disable react/sort-comp */
import React from 'react';

import Options from 'components/Options';
// import DraggableTable from './DraggableTable';
import { sort } from 'utils/sorting';

import Pagination from '../Pagination';

import CustomTable from './CustomTable';

class SmartTable extends React.Component {
  constructor(props) {
    super(props);
    const initColumns = props.defaultFields.map((f) => props.fields[f]);
    this.state = {
      columns: props.withOptions
        ? initColumns
        : Object.keys(props.fields).map((f) => props.fields[f]),
      options: props.defaultFields,
      itemsPerPage: 5,
      currentPage: 1,
      criteria: '',
      ascending: true,
    };
  }

  static defaultProps = {
    defaultFields: [],
  };

  handleChange = (value) => {
    const { options } = this.state;
    if (options.includes(value)) {
      this.setState({ options: [...options, value] });
    } else {
      this.setState({ options: options.filter((el) => el !== value) });
    }
  };

  saveColumns = () => {
    const { options } = this.state;
    const { fields } = this.props;
    const columns = options.map((o) => fields[o]);
    this.setState({ columns });
  };

  setItemsPerPage = (itemsPerPage) => {
    this.setState({ itemsPerPage, currentPage: 1 });
  };

  setPage = (currentPage) => {
    this.setState({ currentPage });
  };

  setSorting = (name) => {
    const { criteria, ascending } = this.state;
    if (criteria === name) {
      if (!ascending) {
        this.setState({ criteria: '', ascending: true });
      } else {
        this.setState({ ascending: false });
      }
    } else {
      this.setState({ criteria: name, ascending: true });
    }
  };

  render() {
    const { data, fields, withOptions, draggable, pagination, ...restProps } =
      this.props;
    const { columns } = this.state;
    const { options, itemsPerPage, currentPage, criteria, ascending } =
      this.state;

    const dataPerPage = sort(data, criteria, ascending).slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage,
    );
    const table = draggable ? null : ( // /> //   {...restProps} //   ascending={ascending} //   criteria={criteria} //   setSorting={this.setSorting} //   data={dataPerPage} //   columns={columns} // <DraggableTable
      <CustomTable
        columns={columns}
        data={dataPerPage}
        setSorting={this.setSorting}
        criteria={criteria}
        ascending={ascending}
        {...restProps}
      />
    );
    return (
      <div className="App">
        {withOptions && (
          <Options
            options={Object.keys(fields).map((f) => fields[f])}
            selectedOptions={options}
            onChange={this.handleChange}
            onSave={this.saveColumns}
          />
        )}
        {pagination ? (
          <Pagination
            setItemsPerPage={this.setItemsPerPage}
            pagination={pagination}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            totalRecords={data.length}
            setPage={this.setPage}
          >
            {table}
          </Pagination>
        ) : (
          table
        )}
      </div>
    );
  }
}

export default SmartTable;
